/* eslint-disable no-param-reassign */
export function formatDate(
  date: Date | string,
  locale = 'en-GB',
  {
    month = 'long',
    includeYear = true,
    timezone,
  }: {
    month?: string;
    includeYear?: boolean;
    timezone?: string;
  } = {}
) {
  date = new Date(date);
  const dateFormat = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: month as any,
    year: 'numeric',
    timeZone: timezone,
  });
  const result = dateFormat.format(date);
  if (includeYear) {
    return result;
  }
  return result
    .replace(/20\d\d/, '')
    .replace(',', '')
    .trim();
}
